import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { fetchDataFromCookies } from '@/services/util/cookies.util';
import { DefaultLocale } from '@/types/locale.types';
import { setSessionData } from '@/utils/analytics.util';
import { getStoreId } from '@/utils/cart.util';
import { SESSION_KEYS } from '@/utils/constants';
import { buildPlpPagePath, buildSearchPagePath } from '@/utils/path.util';

export function usePathBuilder() {
  const router = useRouter();
  const { storeId: qStoreId, lang } = router.query;
  const cookieData = fetchDataFromCookies();
  const storeId = cookieData.storeId ?? getStoreId(Number(qStoreId));
  const qLang = typeof lang === 'string' ? lang : DefaultLocale;

  useEffect(() => {
    setSessionData(SESSION_KEYS.STORE_ID, storeId);
  }, [storeId]);

  return {
    buildPlpPagePath: (
      params: Omit<Parameters<typeof buildPlpPagePath>[0], 'lang'>
    ) => buildPlpPagePath({ ...params, lang: qLang }),

    buildSearchPagePath: (
      params: Omit<Parameters<typeof buildSearchPagePath>[0], 'lang'>
    ) => buildSearchPagePath({ ...params, lang: qLang }),
  };
}
